import * as yup from "yup";

export const myBusinessFormSchema = yup.object({
  companyName: yup
    .string()
    .trim()
    .required("Името на фирмата е задължително")
    .max(200, "Името на фирмата може да е до 200 символа"),
  bulstat: yup
    .string()
    .trim()
    .required("Булстат/ЕИК е задължителен")
    .matches(/^\d{9}$|^\d{13}$/, "Булстат/ЕИК трябва да съдържа 9 или 13 цифри"),
  address: yup
    .string()
    .trim()
    .required("Адресът е задължителен")
    .max(500, "Адресът може да е до 500 символа"),
  city: yup
    .string()
    .trim()
    .required("Градът е задължителен")
    .max(100, "Градът може да е до 100 символа"),
  country: yup
    .string()
    .trim()
    .required("Държавата е задължителна")
    .max(100, "Държавата може да е до 100 символа"),
  mol: yup
    .string()
    .trim()
    .required("МОЛ е задължителен")
    .max(200, "МОЛ може да е до 200 символа"),
});

export type IMyBusinessFormModel = yup.InferType<typeof myBusinessFormSchema>;

export const myBusinessFormDefaultValues: IMyBusinessFormModel = {
  companyName: "",
  bulstat: "",
  address: "",
  city: "",
  country: "България",
  mol: "",
};
